import { Component,Input, OnInit} from '@angular/core';
import { NotificationService } from 'src/app/Service/notification.service';
import { MyProfileService } from 'src/app/User/Pages/my-profile/my-profile.service';
import { HttpClient } from '@angular/common/http';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/Service/auth.service';
import { FilesService } from '../../../../Pages/files/files-api.service';
import { GlobalConstants } from 'src/app/utils/global-constants';

@Component({
    selector: 'app-share-upload-link',
    templateUrl: './share-upload-link.component.html',
    styleUrls: ['./share-upload-link.component.css'],
    standalone: false
})
export class ShareUploadLinkComponent implements OnInit {
  secureLink;
  form: UntypedFormGroup;
  otherIndividuals: UntypedFormArray;
  showEmail = false;
  @Input() folderid = '';
  myFamilyInfo: any;
  executor: any;
  executorForm: UntypedFormGroup;
  currentIndividual: number;
  isDeliveryDate: boolean = false;
  months = [
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
  ];
  date: Date;
  linkExpireTime = [
    { key: '1', value: '30 days' },
    { key: '2', value: '12 months' },
    { key: '3', value: 'Forever' },
  ];
  subscriptions = new Subscription();
  constructor(
    public fileDataService: FilesService,
    public http: HttpClient,
    private fb: UntypedFormBuilder,
    public notify: NotificationService,
    public activatedRoute: ActivatedRoute,
    public auth: AuthService,
    public modal: NgbModal,
    private myProfileService: MyProfileService,
  ) {}
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  ngOnInit(): void {
    this.getExecutor(true);
    this.form = this.fb.group({
      forFamilyCentralMembers: [true],
      otherIndividuals: this.fb.group({
        email: [
          '',
          [
            Validators.required,
            Validators.pattern(GlobalConstants.emailPattern),
          ],
        ],
        phoneNumber: ['', [Validators.required]],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        specificDate: this.fb.group({
          day: [''],
          month: [''],
          year: [''],
        }),
        deliveredOnDate: [false],
        deliveredOnPassing: [false],
        deliveryDate: ['',[Validators.required]],
      }),
    });
    this.executorForm = this.fb.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      phoneNumber: [null, [Validators.required]],
      email: [null, [Validators.required]],
      relationId: [1, [Validators.required]],
      message: ['', [Validators.required]],
    });
  }
  getMonth(req) {
    return this.months.filter((f) => f.key === req);
  }

  async getExecutor(forceRefresh = false) {
    await this.myProfileService.GetProfile(forceRefresh).toPromise();
    if (this.myProfileService.myProfileInfo.confidantes.length) {
      this.executor = this.myProfileService.myProfileInfo.confidantes[0];
    }
  }

  setSpecificDay() {
    this.date = new Date();
    if (this.form.controls['otherIndividuals'].value.deliveryDate == 1) {
      this.date.setDate(this.date.getDate() + 30);
    } else if (this.form.controls['otherIndividuals'].value.deliveryDate == 2) {
      this.date.setFullYear(this.date.getFullYear() + 1);
    } else {
      this.date.setFullYear(this.date.getFullYear() + 5);
    }
    const resp = this.date;
    this.form.controls['otherIndividuals'].value.deliveryDate = resp;
    this.form.controls['otherIndividuals'].value.specificDate.day = resp
      .getDate()
      .toString();
    this.form.controls['otherIndividuals'].value.specificDate.month = (
      resp.getMonth() + 1
    ).toString();
    this.form.controls['otherIndividuals'].value.specificDate.year = resp
      .getFullYear()
      .toString();
    this.form.updateValueAndValidity();
  }
  async sharelink() {
    this.setSpecificDay();
    if (
      !this.form.valid &&
      !this.form.controls['forFamilyCentralMembers'].value
    ) {
      this.form.markAllAsTouched();
      this.notify.showWarning(
        'Please enter all required fields to Share an Upload Link.'
      );
      return;
    }
    const payload = {
      folderId: this.folderid,
      executorId: this.form.controls['forFamilyCentralMembers'].value
        ? this.executor?.id
        : null,
      Others: this.form.controls['forFamilyCentralMembers'].value
        ? this.executor[0]
        : this.form.controls['otherIndividuals'].value,
    };
    this.fileDataService.FileUploadRequest(payload).subscribe(async (data) => {
      if (data?.succeeded) {
        this.notify.showSuccess('Secure share link shared successfully');
        this.modal.dismissAll();
      }
    });
  }
}
